import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Bell, X } from "lucide-react";

export default function NoticesBanner() {
  const [notices, setNotices] = useState([]);

  const load = () => api.get("/me/notices").then((r) => setNotices(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const ack = async (id) => {
    await api.post(`/me/notices/${id}/ack`);
    setNotices((n) => n.filter((x) => x.id !== id));
  };

  if (notices.length === 0) return null;

  return (
    <div className="bg-ai/10 border-b border-ai/20" data-testid="notices-banner">
      {notices.map((n) => (
        <div key={n.id} className="flex items-start gap-3 px-6 py-3" data-testid={`notice-${n.id}`}>
          <Bell className="w-4 h-4 text-ai shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-foreground"><span className="font-medium">Aviso da administração:</span> {n.message}</p>
            <p className="text-[11px] text-muted-foreground mt-0.5">{n.from} · {(n.created_at || "").slice(0, 10)}</p>
          </div>
          <button onClick={() => ack(n.id)} className="text-muted-foreground hover:text-foreground shrink-0"
            data-testid={`notice-ack-${n.id}`} title="Marcar como lido">
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
